import { Component, Vue } from 'vue-property-decorator';
import OpusBRequest from '@/shared/service/OpusBRequest.service';
import { AccountStoreModule } from '@/shared/config/store/account-store';
import moment from 'moment';

@Component
export default class PendingApproval extends Vue{

    employeeid: number= parseInt(AccountStoreModule.context.getters.account.employeeId);
    opusbrequest: OpusBRequest= new OpusBRequest();

    overtimeApproval:number= 0;
    leaveApproval:number=0;
    timesheetApproval:number=0;

    created(){
        this.loadApprovalData();
    }

    async loadApprovalData():Promise<void>{
        await this.getData('HRM_OvertimeRequest').then(r=> this.overtimeApproval = r);
        await this.getData('HRM_LeaveRequest_H').then(r=> this.leaveApproval= r);        
        await this.getData('HRM_TrsTimesheetH').then(r=> this.timesheetApproval= r);
        
    }

    async getData(tablename:string):Promise<number> {

        return new Promise((resolve, reject)=> {
            this.opusbrequest.get(`api/v1/models/${tablename}?filter=C_BPartner_ID=${this.employeeid} AND docStatus='DR'`,{})
            .then(res=> {
                if(!!res && Array.isArray(res)) resolve(res.length);
                resolve(0);
            }).catch(e=> {
                console.log({e});
                reject();
            });
        })
       
    }
}